/* Koemi Studio · cart drawer behaviour (sections/km-cart-drawer.liquid).
   window.kmCart = { open, close, refresh, add(formData) } */
(function () {
  if (window.kmCart) return;
  var SECTION = 'km-cart-drawer';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lastFocus = null;
  function el() { return document.getElementById('km-cart'); }
  function setCount(n) {
    document.querySelectorAll('[data-cart-mini-count]').forEach(function (c) { c.textContent = n > 0 ? n : ''; });
  }
  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('km-cart');
    var cur = el();
    if (!fresh || !cur) return;
    var open = cur.classList.contains('is-open');
    cur.querySelector('.kmc__panel').innerHTML = fresh.querySelector('.kmc__panel').innerHTML;
    cur.setAttribute('data-count', fresh.getAttribute('data-count'));
    cur.classList.toggle('is-open', open);
    setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
  }
  function busy(on) { var c = el(); if (c) c.classList.toggle('is-busy', on); }
  function refresh() {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j[SECTION]) swap(j[SECTION]); })
      .catch(function () {});
  }
  function open() {
    var c = el(); if (!c) return;
    lastFocus = document.activeElement;
    c.classList.add('is-open');
    c.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('kmc-lock');
    var p = c.querySelector('.kmc__panel'); if (p) p.focus({ preventScroll: true });
  }
  function close() {
    var c = el(); if (!c) return;
    c.classList.remove('is-open');
    c.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kmc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function change(key, qty) {
    busy(true);
    return fetch(root + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTION })
    }).then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.sections && j.sections[SECTION]) swap(j.sections[SECTION]); else return refresh(); })
      .catch(function () { return refresh(); })
      .then(function () { busy(false); });
  }
  /* formData: a FormData from the product form (id, quantity, properties...) */
  function add(formData) {
    formData.append('sections', SECTION);
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
        if (res.json.sections && res.json.sections[SECTION]) swap(res.json.sections[SECTION]);
        else return refresh();
      }).then(function () { open(); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-mini-toggle]')) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      refresh(); open(); return;
    }
    if (t.closest('[data-km-cart-close]')) { close(); return; }
    var q = t.closest('[data-km-qty]');
    if (q && q.closest('#km-cart')) {
      var item = q.closest('[data-key]');
      if (item) change(item.getAttribute('data-key'), parseInt(q.getAttribute('data-km-qty'), 10));
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    var c = el();
    if (e.key === 'Escape' && c && c.classList.contains('is-open')) close();
  });
  /* A page restored from the back/forward cache can show an old cart */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  window.kmCart = { open: open, close: close, refresh: refresh, add: add };
})();
